import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ErisFormFieldType } from 'eris-forms';
import { first } from 'rxjs/operators';
import PhoneNumberCountryCodes from './international-phone-numbers'

@Component({
  selector: 'app-international-phone',
  templateUrl: './international-phone.component.html',
  styleUrls: ['./international-phone.component.css']
})
export class InternationalPhoneComponent extends ErisFormFieldType implements OnInit, AfterViewInit {

  public phone: string = '';
  public countryCode:  string= '';
  public phonesCountryCode = PhoneNumberCountryCodes;
  public required = false;
  public editing = false;
  public isDataFilled = false;
  public disabled = false;

  constructor(private cdr: ChangeDetectorRef) { 
    super();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.required = this.field.templateOptions?.required;
      this.editing = this.field.templateOptions?.editing;
      this.isDataFilled = this.field.templateOptions?.isDataFilled;
      this.disabled = this.field.templateOptions?.disabled;

      const extractPhone = (val: string) => {
        if (!val) {
          if (!this.countryCode) {
            const et = this.phonesCountryCode.find(p => p.countryCode === 'ET');
            this.countryCode = et ? et.code : '+251';
          }
          return;
        }
        const strVal = String(val).trim();
        const sortedCodes = [...this.phonesCountryCode].sort((a, b) => b.code.length - a.code.length);
        for (const phone of sortedCodes) {
          if (strVal.startsWith(phone.code)) {
            this.countryCode = phone.code;
            this.phone = strVal.substring(phone.code.length);
            this.cdr.detectChanges();
            return;
          }
        }
        this.phone = strVal;
        this.cdr.detectChanges();
      };

      const initialVal = this.field?.formControl?.value || this.formControl?.value;
      if (initialVal) {
        extractPhone(initialVal);
      } else {
        const et = this.phonesCountryCode.find(p => p.countryCode === 'ET');
        this.countryCode = et ? et.code : '+251';
      }

      this.field?.formControl?.valueChanges.subscribe((val) => {
        if (val && val !== (this.countryCode + this.phone)) {
          extractPhone(val);
        }
      });
      
      //international phone number pattern => [+ (1-4 country code) (9 - 12 number)]
      if(!this.field.templateOptions?.dependsOnField){
        if(this.required){
          this.field.formControl.setValidators([Validators.required, Validators.pattern("\\+[0-9]{10,16}")]);       
        } else {
          this.field.formControl.setValidators([Validators.pattern("\\+[0-9]{10,16}")]);
        }
        this.field.formControl.updateValueAndValidity();

      } else {
        this.form.parent.get(this.field.templateOptions.dependsOnField)?.valueChanges.subscribe(() => {
          // need to wait for required option to be updated
          setTimeout(() => {
            this.required = this.field.templateOptions.required;
            if(!this.required){
              this.field.formControl.setValidators([Validators.pattern("\\+[0-9]{10,16}")]);
              this.phone = null;
              this.countryCode = null;
              this.field.formControl.setValue(null);
            }else {
              this.field.formControl.setValidators([Validators.required, Validators.pattern("\\+[0-9]{10,16}")]); 
            }
            this.field.formControl.updateValueAndValidity();
            this.cdr.detectChanges();
          }, 100);
        })
      }
    }) 
  }

  onCountryCodeChange() {
    if (this.phone && String(this.phone).trim()) {
      this.saveInput();
    }
  }

  saveInput(){
    if (!this.phone || !String(this.phone).trim()) {
      if (this.formControl.value) {
        this.formControl.setValue(null);
        this.formControl.markAsDirty();
        this.formControl.updateValueAndValidity();
      }
      return;
    }
    const next = (this.countryCode || '+251') + String(this.phone).trim();
    if (this.formControl.value !== next) {
      this.formControl.setValue(next);
      this.formControl.markAsDirty();
      this.formControl.updateValueAndValidity();
    }
  }
}
